import "./index.css";
import clsx from "clsx";
import type { ReactNode } from "react";

type IProps = {
  children: ReactNode;
  className?: string;
};

export const Page = ({ children, className }: IProps) => {
  const rootClass = clsx("page", className);
  return <div className={rootClass}>{children}</div>;
};
